import React from "react";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";

const App: React.FC = () => {
  return (
    <div className="w-full lg:w-3/5 px-4 mx-auto">
      <Header />
      <Hero />
      <Services />
      <Contact />
      <Footer />
    </div>
  );
};

export default App;
